// A brief full-screen colour flash whenever `trigger` changes to a new truthy value (emerald when right).
// Opacity only, on a fixed layer that never takes a tap. Reduced motion: a softer, slower fade.
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useFire } from './fire';
import { canAnimate, prefersReducedMotion } from './reduced';

export function ScreenFlash({ trigger, color, durationMs = 460 }: { trigger: unknown; color: string; durationMs?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  useFire(trigger, () => {
    const el = ref.current; if (!el || !canAnimate()) return;
    const soft = prefersReducedMotion();
    const a = el.animate([{ opacity: 0 }, { opacity: soft ? 0.16 : 0.38, offset: 0.18 }, { opacity: 0 }], { duration: soft ? durationMs * 1.4 : durationMs, easing: 'ease-out' });
    return () => a.cancel();
  });
  if (typeof document === 'undefined') return null;
  return createPortal(<div ref={ref} aria-hidden="true" style={{ position: 'fixed', inset: 0, background: color, opacity: 0, pointerEvents: 'none', zIndex: 60, willChange: 'opacity' }} />, document.body);
}
